import {
  promptUserWithCatalog,
  NewSessionSelection,
  ResumeSessionSelection,
} from "./catalog";
import { apiFactory } from "@dcs/schema-tools/api";
import { tokenGenerator, dropRendererMetaData } from "./utils";
import './css/button.css'

const DL_CLOUD_HOST = "formhero.cloud";

const dataSet = new (apiFactory({ host: "formhero.cloud" }).DataSetInterface)(
  "quadient/save-resume/catalog"
);

export default async function main(formhero, formCoordinates, setView) {
  formhero.setFormHeroHost(DL_CLOUD_HOST);
  const CATALOG_POINTER = Object.freeze({
    organization: "iforms",
    team: "custom-demos",
    form: "save-resume-catelog",
    formhero,
  });
  let sessionData = {},
    state = "catalog",
    sessionCode;

  if (state === "catalog") {
    const userCatalogSelection = await promptUserWithCatalog(CATALOG_POINTER);

    if (userCatalogSelection instanceof ResumeSessionSelection) {
      state = "resume-session";
      sessionCode = userCatalogSelection.sessionCode();
    } else if (userCatalogSelection instanceof NewSessionSelection) {
      state = "launch-form";
    }
  }

  if (state === "resume-session") {
    try {
      sessionData = await dataSet.search(sessionCode);

      // if we get to here, a session was recovered
      state = "launch-form";
      // prep data for resume; (including FORMHERO attributes breaks load)
      sessionData = dropRendererMetaData(sessionData);
    } catch (e) {
      // assume there is no session.
      setView({view:"textDisplay",message:"We were unable to locate a session associated with the entered session code. Please verify the code and try again."})
      // TODO: message to user, and then restart catalog prompt
    }
  }

  if (state === "launch-form") {
    console.log(formCoordinates.organization);
    formhero
      .loadForm(
        {
          organization: formCoordinates.organization,
          team: formCoordinates.team,
          form: formCoordinates.form,
          saveButtonMarkup: `<div class="custom-save-button">Save & Close</div>`,
          cancelButtonMarkup: "<p></p>",
          closeButtonMarkup: '<p></p>',
          onStatusFn: function (status) {},
          onCloseFn: function () {
            console.log("The user closed the modal");
          }, // e.g. post thank you
        },
        sessionData
      )
      .then(
        function submit(successResult) {
          console.log("Form Submitted:", successResult);
          // TODO: clear data-sets record to prevent subsequent resume
          // The successResult object contains the data that was collected.
          // Use this object and space to process the data via your services.
        },
        function suspend(suspendResult) {
          // The suspendedResult object contains the data that was collected.
          // Use this object and space to persist a session.
          console.log("Form Suspended :", suspendResult);
          const {
            state,
            collectedData,
          } = suspendResult;

          console.log(state)

          if (state !== "form-saved-but-incomplete") {
            return;
          }

          // suspend session logic
          console.log(collectedData);
          sessionCode ||= `${
            collectedData["FORMHERO.FORM_SLUG"]
          }-${tokenGenerator()}`;
          dataSet.upsert(sessionCode, {
            ...collectedData,
          });
          setView({
            view: "textDisplay",
            message: `Your session has been saved. Your session ID is <br><br><strong>${sessionCode}</strong> <br><br>please record this in a safe place – it will allow the bearer to recover your session. Your code will be valid for the next 60 days.`,
          });
        }
      );
  }
}
